export default {
    ACTION_BAR_RENEWAL: {
        fi: 'Uusi toimintopaneeli',
        en: 'New action bar',
    },
}
